import axios from 'axios';
import { API_DIPENDENTI_URL } from '../config';
import moment from 'moment';


export const cedoliniList = async (token) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}buste_paga`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const cedoliniDetail = async (token, id) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}buste_paga/${id}`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const setCedolinoRead = async (token, id) => {
  const response = await axios.post(`${API_DIPENDENTI_URL}buste_paga/${id}/read`, {}, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}


export const cuList = async (token) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}cu`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const cuDetail = async (token, id) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}cu/${id}`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const setCuRead = async (token, id) => {
  const response = await axios.post(`${API_DIPENDENTI_URL}cu/${id}/read`, {}, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}


export const documentiList = async (token) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}docs`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const documentiDetail = async (token, id) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}docs/${id}`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const setDocumentiRead = async (token, id) => {
  const response = await axios.post(`${API_DIPENDENTI_URL}docs/${id}/read`, {}, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const fetchProfile = async (token) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}profile`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const acceptPrivacy = async (token) => {
  const response = await axios.post(`${API_DIPENDENTI_URL}accept_privacy`, {}, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

// passowords

export const changePassword = async (data) => {
  const response = await axios.post(`${API_DIPENDENTI_URL}cambia_password`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    }
  })
  return response.data;
}


export const recuperaPassword = async (data) => {
  const body = data;

  const response = await axios.post(`${API_DIPENDENTI_URL}recupera_password`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  return response.data;
}

export const updatePassword = async (token, data) => {
  const response = await axios.post(`${API_DIPENDENTI_URL}update_password`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      'Authorization': `${token}`,
    }
  })
  return response.data;
}


export const getBalances = async (token) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}presenze/balances/`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const getTipiGiustificativi = async (token) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}presenze/justifications/`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const getRichiesteGiustificativi = async (token, query) => {
  // add query params like page, page_size, status
  const response = await axios.get(`${API_DIPENDENTI_URL}presenze/justification-requests/`, {
    params: {
      page: query.page || 1,
      page_size: query.page_size || 50,
      status: query.status,
      start_date: query.start_date,
      end_date: query.end_date,
    },
    headers: {
      'Authorization': `${token}`,
    }
  });
  return response.data;
};

export const createRichiestaGiustificativo = async (token, data) => {

  //   "datetime_from": "2024-06-19T20:08:48.475Z",
  // "datetime_to": "2024-06-19T20:08:48.475Z",
  //   "note": "string",
  //     "justification": 0
  let body = {
    datetime_from: data.datetime_from, // FIXME: check the timezone and fix it
    datetime_to: data.datetime_to, // FIXME: check the timezone and fix it
    note: data.note,
    justification: data.justification
  }

  const response = await axios.post(`${API_DIPENDENTI_URL}presenze/justification-requests/`, data, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const getShifts = async (token, query) => {

  // formate date in the query like yyyy-mm-dd
  let enddate = new Date(query.end);
  let startdate = new Date(query.start);
  query.end = enddate.toISOString().split('T')[0];
  query.start = startdate.toISOString().split('T')[0];


  // add query params like page, page_size, status
  const response = await axios.get(`${API_DIPENDENTI_URL}presenze/shifts/`, {
    params: {
      end_date: query.end,
      start_date: query.start,
    },
    headers: {
      'Authorization': `${token}`,
    }
  }
  )
  return response.data;
}


export const getAlerts = async (token, query, category) => {
  // add query params like page, page_size, status
  const response = await axios.get(`${API_DIPENDENTI_URL}presenze/alerts/`, {
    params: {
      is_read: query.is_read,
      ...(query.page ? {page: query.page} : {}), ...(query.page_size ? {page_size: query.page_size} : {}),
      category: category,     
    },
    headers: {
      'Authorization': `${token}`,
    }
  }
  )
  return response.data;
}

export const getAlertDetail = async (token, id) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}presenze/alerts/${id}/`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const setAlertRead = async (token, id) => {
  const response = await axios.post(`${API_DIPENDENTI_URL}presenze/alerts/${id}/set-as-read/`, {}, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const createRichiestaRimborsoSpese = async (token, data) => {
  const response = await axios.post(`${API_DIPENDENTI_URL}cost-refunds/`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const storicoRichiesteRimborsoSpese = async (token, page, status, pageSize=10, month, year) => {
  const response = await axios.get(`${API_DIPENDENTI_URL}cost-refunds/`, {
    headers: {
      'Authorization': `${token}`,
    },
    params: {
      page: page,
      page_size: pageSize,
      status: status,
      month: month,
      year: year
    }
  });
  return response.data;
}

export const deleteRichiestaRimborsoSpese = async (token, id) => {
  const response = await axios.delete(`${API_DIPENDENTI_URL}cost-refunds/${id}/`,
   {
      headers: {
        'Authorization': `${token}`,
      },
    });
  return response.data;
};

export const patchRichiestaRimborsoInviata = async (token, id, updatedData) => {
  const formData = new FormData();
  
  formData.append('title', updatedData.title);
  formData.append('description', updatedData.description);
  formData.append('amount', updatedData.amount);
  formData.append('date', updatedData.date);

  if(updatedData.hasOwnProperty('file'))
    formData.append('file_binary', updatedData.file);

  const response = await axios.patch(`${API_DIPENDENTI_URL}cost-refunds/${id}/`, 
    formData, 
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `${token}`,
      }
    }
  );
  return response.data;
};


export const getTimbrature = async (token, query) => {

  let enddate = new Date(query.end);
  let startdate = new Date(query.start);
  query.end = enddate.toISOString().split('T')[0];
  query.start = startdate.toISOString().split('T')[0];
  
  const response = await axios.get(`${API_DIPENDENTI_URL}presenze/inouts/`, {
    params: {
      to_date: query.end,
      from_date: query.start,
      page: query.page || 1,
      page_size: query.page_size || 100,
    },
    headers: {
      'Authorization': `${token}`,
    }
  }
  )
  return response.data;
}



export const getEmployeeSettings = async (token) => {
    const response = await axios.get(`${API_DIPENDENTI_URL}presenze/settings/`,
    {
        headers: {
          'Authorization': `${token}`,
        },
    });
    return response;
};

export const updateEmployeeSettings = async (token, settings) => {
    const response = await axios.patch(`${API_DIPENDENTI_URL}presenze/settings/`, settings, {
      headers: {
        'Authorization': `${token}`,
      },
    });
    return response.data;
};


